import { render } from "./two-factor-setup.vue?vue&type=template&id=200e3b92"
import script from "./two-factor-setup.vue?vue&type=script&lang=js"
export * from "./two-factor-setup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__